
import ArticleInfoBaseTemplate from './ArticleInfoBaseTemplate';
import ContentRecipe from '@core/components/UI/ContentRecipe.vue';
import ArticleInfoTags from '@root/modules/article/components/info/ArticleInfoTags.vue';
import ArticleInfoEasyReadSocial from './ArticleInfoEasyReadSocial.vue';

export default ArticleInfoBaseTemplate.extend({
  components: {
    ContentRecipe,
    ArticleInfoTags,
    ArticleInfoEasyReadSocial,
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '');
    },
    commentsNoBrackets() {
      const { commentsNoBrackets } = this.$channelConfig('settings');
      return commentsNoBrackets;
    },
    isLiveBlogArticle() {
      return this.article && this.article.settings?.articleTemplate && this.article.settings?.articleTemplate === 'liveBlog';
    },
    isAdultArticle() {
      return this.article.settings['icon.adult'] || this.article.settings['articleAdultContent'] || false;
    },
    isEasyChannel() {
      const { id } = this.$channelConfig('settings');
      return id === 'zinios-visiems';
    },
  },
  methods: {
    confirmAdult() {
      this.$store.commit('article/setIsAdultConfirmed', true);
    },
  },
});
